import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Transition as _Transition } from "vue";
import _imports_0 from '@/assets/vouchers-online.svg';
import _imports_1 from '@/assets/vouchers-in-store.svg';
import _imports_2 from '../../assets/DiscountUnderline.png';
const _hoisted_1 = {
    key: 1,
    class: "no-results"
};
const _hoisted_2 = {
    key: 0,
    class: "voucher-list"
};
const _hoisted_3 = ["href", "onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "bold" };
const _hoisted_6 = {
    key: 0,
    class: "description"
};
const _hoisted_7 = { class: "mt-1" };
const _hoisted_8 = {
    key: 0,
    src: _imports_0,
    class: "online-icon"
};
const _hoisted_9 = {
    key: 1,
    src: _imports_1,
    class: "in-store-icon"
};
const _hoisted_10 = {
    key: 1,
    class: "spend-info"
};
const _hoisted_11 = { class: "amount-content" };
const _hoisted_12 = { class: "label" };
const _hoisted_13 = {
    key: 0,
    class: "value"
};
const _hoisted_14 = {
    key: 1,
    class: "value"
};
const _hoisted_15 = {
    key: 2,
    class: "discount-underline",
    src: _imports_2
};
const _hoisted_16 = {
    key: 3,
    class: "saving-info"
};
import { ref, computed, useTemplateRef, onMounted, nextTick } from 'vue';
import FavoriteChip from './FavoriteChip.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherList',
    props: {
        search: { type: Boolean },
        preSearch: {},
        categories: {},
        vouchers: {},
        formatter: {},
        today: {},
        yesterday: {},
        showAll: { type: Boolean },
        showSaving: { type: Boolean },
        spendLabel: {},
        navToVoucher: { type: Boolean, default: true },
        label: { default: 'Save' },
        showFavourites: { type: Boolean },
        showLastMonthSpend: { type: Boolean },
        showDescription: { type: Boolean },
        groupFavourites: { type: Boolean }
    },
    emits: ["onFilterApplied", "favouriteToggled", "voucher-clicked"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const query = ref(props.preSearch ?? null);
        const context = ref(false);
        const searchRef = useTemplateRef('searchRef');
        const searchedVouchers = computed(() => {
            const vouchersList = props.vouchers || [];
            let ret = [];
            if (query.value == null && !props.categories) {
                ret = props.showAll ? vouchersList : [];
                emit('onFilterApplied', ret ? ret.length : 0);
                return ret.length > 0 ? ret : null;
            }
            if (query.value == "" || query.value == null) {
                ret = vouchersList;
            }
            else {
                ret = vouchersList.filter(v => {
                    const merchantName = v.merchant?.name || v.discount?.merchant?.name || '';
                    return merchantName.toLowerCase().includes(query.value.toLowerCase());
                });
            }
            if (props.categories) {
                const toSearch = ret;
                ret = [];
                const cats = props.categories.split(",");
                cats.forEach(cat => {
                    const found = toSearch.filter(v => {
                        const categories = v.merchant?.categories || v.discount?.merchant?.categories || '';
                        return categories.toLowerCase().includes(cat.toLowerCase());
                    });
                    found.forEach(f => {
                        if (!ret.includes(f))
                            ret = [...ret, f];
                    });
                });
            }
            emit('onFilterApplied', ret.length);
            return ret;
        });
        const normalizedVouchers = computed(() => {
            return searchedVouchers.value?.map(v => {
                // Handle new structure with discount property
                if (v.discount) {
                    return {
                        id: v.discount.id,
                        merchant: v.discount.merchant,
                        cardUrl: v.discount.cardUrl,
                        description: v.discount.description,
                        online: v.discount.online,
                        inStore: v.discount.inStore,
                        stackWith: v.discount.stackWith,
                        favourite: v.discount.favourite,
                        effectiveDiscountPercentage: v.discount.effectiveDiscountPercentage,
                        // Add the new totals
                        totalVouchers: v.totalVouchers,
                        totalAmount: v.totalAmount
                    };
                }
                // Handle old structure (direct properties)
                return v;
            }) || [];
        });
        const favouritesGroup = computed(() => normalizedVouchers.value.filter((v) => v.favourite));
        const allGroup = computed(() => normalizedVouchers.value.filter((v) => !v.favourite));
        // Single ordered list feeding the row loop: favourites first when grouping is
        // enabled, otherwise the natural order. Replaces the old duplicate markup blocks.
        const orderedVouchers = computed(() => props.groupFavourites ? [...favouritesGroup.value, ...allGroup.value] : normalizedVouchers.value);
        function onClear() {
            searchRef.value?.blur();
        }
        onMounted(async () => {
            if (props.search) {
                await nextTick();
                searchRef.value?.focus();
            }
        });
        function toggleFavourite(v, event) {
            if (event) {
                event.stopPropagation();
                event.preventDefault();
            }
            emit('favouriteToggled', v);
        }
        function handleVoucherClick(v) {
            emit('voucher-clicked', v);
        }
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_divider = _resolveComponent("v-divider");
            return (_openBlock(), _createElementBlock("div", {
                class: "voucher-list",
                onClick: _cache[4] || (_cache[4] = event => { event.stopPropagation(); })
            }, [
                (_ctx.search)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        class: "mb-4"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "search-col" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                        ref_key: "searchRef",
                                        ref: searchRef,
                                        modelValue: query.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((query).value = $event)),
                                        "prepend-inner-icon": "mdi-magnify",
                                        density: "compact",
                                        label: "Search",
                                        variant: "solo",
                                        flat: true,
                                        "hide-details": "",
                                        clearable: "",
                                        "single-line": "",
                                        "bg-color": "#eeeeee",
                                        onClick: _cache[1] || (_cache[1] = ($event) => (query.value = '')),
                                        onBlur: _cache[2] || (_cache[2] = ($event) => { if (query.value == '') {
                                            query.value = null;
                                        } }),
                                        "onClick:clear": _cache[3] || (_cache[3] = ($event) => (onClear()))
                                    }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (_ctx.search && query.value && normalizedVouchers.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No vouchers match \"" + _toDisplayString(query.value) + "\" ", 1))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (normalizedVouchers.value && normalizedVouchers.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedVouchers.value, (v) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: v.id
                                    }, [
                                        _createElementVNode("a", {
                                            href: _ctx.navToVoucher ? '#/vouchers/amount/' + v.id : 'javascript:void(0)',
                                            onClick: ($event) => (_ctx.navToVoucher ? null : handleVoucherClick(v))
                                        }, [
                                            _createVNode(_component_v_row, {
                                                class: _normalizeClass([_ctx.showSaving ? '' : 'mb-1', "d-flex voucher-row"])
                                            }, {
                                                default: _withCtx(() => [
                                                    (_ctx.showFavourites && !context.value)
                                                        ? (_openBlock(), _createBlock(FavoriteChip, {
                                                            key: 0,
                                                            class: "favouriteChip",
                                                            isFavorited: v.favourite,
                                                            onFavoriteClicked: ($event) => (toggleFavourite(v))
                                                        }, null, 8, ["isFavorited", "onFavoriteClicked"]))
                                                        : _createCommentVNode("", true),
                                                    _createVNode(_component_v_col, { class: "v-col-3 icon-col" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("img", {
                                                                src: v.cardUrl,
                                                                class: _normalizeClass('icon ' + (_ctx.showSaving ? 'mt-3' : 'mt-2'))
                                                            }, null, 10, _hoisted_4)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, { class: "v-col-6 details-col" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("span", _hoisted_5, _toDisplayString(v.merchant.name), 1),
                                                            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                                                            (_ctx.showDescription)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(v.description), 1))
                                                                : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_7, [
                                                                (v.online)
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                                                                    : _createCommentVNode("", true),
                                                                (v.inStore)
                                                                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            (_ctx.showSaving)
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                                    _createTextVNode(_toDisplayString(_ctx.spendLabel) + " spend ", 1),
                                                                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatter.format(Math.abs(_ctx.showLastMonthSpend ? v.lastMonthSpend : v.spent))), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    (!context.value)
                                                        ? (_openBlock(), _createBlock(_component_v_col, {
                                                            key: 1,
                                                            class: "v-col-3 amount-col"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "vl" }, null, -1)),
                                                                _createElementVNode("div", _hoisted_11, [
                                                                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.label), 1),
                                                                    (v.totalVouchers)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(v.totalVouchers), 1))
                                                                        : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(v.effectiveDiscountPercentage) + "%", 1)),
                                                                    (!_ctx.showSaving)
                                                                        ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                                                                        : _createCommentVNode("", true),
                                                                    (_ctx.showSaving)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                                            _createElementVNode("strong", null, _toDisplayString(_ctx.formatter.format(_ctx.showLastMonthSpend
                                                                                ? Math.abs(v.lastMonthSpend * (v.effectiveDiscountPercentage / 100))
                                                                                : v.saving)), 1)
                                                                        ]))
                                                                        : _createCommentVNode("", true)
                                                                ])
                                                            ]),
                                                            _: 2
                                                        }, 1024))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1032, ["class"]),
                                            _createVNode(_component_v_divider, { class: "mt-2 mb-2" })
                                        ], 8, _hoisted_3)
                                    ]));
                                }), 128))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ]));
        };
    }
});
